// Spinner.jsx
import React from "react";
import "./spinner.scss";
import { useSelector } from "react-redux";

const Spinner = ({ isDark }) => {
  // store
  const darkThemeFromStore = useSelector((state) => state.Reducer.darkTheme);

  return (
    <div
      className={`spinner ${
        darkThemeFromStore && !isDark
          ? "dark-spinner2"
          : !darkThemeFromStore && isDark
          ? "dark-spinner3"
          : darkThemeFromStore || isDark
          ? "dark-spinner"
          : ""
          
      }`}
    ></div>
  );
};

export default Spinner;
